import { render, staticRenderFns } from "./Openinvicelist.vue?vue&type=template&id=8cf587b4&scoped=true&"
import script from "./Openinvicelist.vue?vue&type=script&lang=js&"
export * from "./Openinvicelist.vue?vue&type=script&lang=js&"
import style0 from "./Openinvicelist.vue?vue&type=style&index=0&id=8cf587b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf587b4",
  null
  
)

export default component.exports